import { fetchCarByNumber } from 'application/core/data/api/av100'

export const getCarByNumber = fetchCarByNumber
